import React from "react";
import {
    Card,
    Box,
    Typography,
    Stack,
    TextField,
    Button,
} from "@mui/material";
import { getGuaranteeInputCount, getGuaranteeTitle } from "src/utils/challengeUtils";

export default function GuaranteeSettings({
    formData,
    guaranteeValues,
    guaranteeSettingsOpen,
    onGuaranteeValueChange,
    onSave,
    onCancel,
}) {
    if (!formData.tempPayoutFormat || !guaranteeSettingsOpen) return null;

    const format = formData.tempPayoutFormat;
    const inputCount = getGuaranteeInputCount(format);
    const title = getGuaranteeTitle(format);

    return (
        <Card sx={{ p: 3, mt: 3, border: "2px solid #667eea" }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#667eea" }}>
                    {title}
                </Typography>
            </Box>

            <Stack spacing={3}>
                {Array.from({ length: inputCount }, (_, i) => {
                    const position = i + 1;
                    const key = `${format}_${position}`;

                    return (
                        <Box
                            key={position}
                            sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                            <Typography
                                variant="body2"
                                sx={{ fontWeight: 500, minWidth: "80px" }}
                            >
                                Position {position}:
                            </Typography>
                            <TextField
                                type="number"
                                value={guaranteeValues[key] || ""}
                                onChange={(e) =>
                                    onGuaranteeValueChange(key, e.target.value)
                                }
                                placeholder="Enter coin amount"
                                sx={{
                                    flex: 1,
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <img
                                            src="/assets/icons/ufcoin.svg"
                                            alt="coin"
                                            style={{ width: 20, height: 20, marginRight: 8 }}
                                        />
                                    ),
                                }}
                            />
                        </Box>
                    );
                })}
            </Stack>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    sx={{
                        borderColor: "#667eea",
                        color: "#667eea",
                        "&:hover": {
                            borderColor: "#5a6fd8",
                            backgroundColor: "rgba(102, 126, 234, 0.04)",
                        },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    sx={{
                        backgroundColor: "#667eea",
                        "&:hover": {
                            backgroundColor: "#5a6fd8",
                        },
                    }}
                >
                    Save
                </Button>
            </Box>
        </Card>
    );
}